import Collapse from "@material-ui/core/Collapse";
import withStyles from "@material-ui/core/styles/withStyles";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import LeavePlan from "..";
import { CommonReducerAction, setHelperText } from "../../../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../../../Actions/LanguageAction";
import CheckImg from "../../../../../../../Assets/Images/aaa.png";
import InputValues from "../../../../../../../Component/InputValues";
import { ReducersTypes } from "../../../../../../../Constants";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {},
});
const ParentState = {
  leaveid: null,
  isgiftallowed: false,
  isgiftapproval: false,
  giftperc: 0,
  noofgift: 0,
  giftActionType: [
    {
      displayname: "All",
      displayvalue: 1,
    },
    {
      displayname: "Fixed Number",
      displayvalue: 2,
    },
    {
      displayname: "Percentage",
      displayvalue: 3,
    },
  ],
  giftactiontypeid: { displayvalue: 2, displayname: "Fixed number" },
};
class GiftALeave extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...ParentState,
      ParentIndex: props.ParentIndex || 0,
      leavetypeid: props.leavetypeid,
    };
  }

  componentWillMount() {
    this.SetValues(this.props);
  }

  componentWillReceiveProps(props) {
    if (this.state.ParentIndex != props.ParentIndex) {
      this.setState({ ParentIndex: props.ParentIndex }, () => {
        this.SetValues(props);
      });
    }
    if (this.state.leavetypeid != props.leavetypeid) {
      this.setState({ leavetypeid: props.leavetypeid });
    }
  }

  SetValues(props) {
    const { ParentIndex } = props;
    if (props.InitLeavesPolicy.policy[ParentIndex]) {
      const { InitLeavesPolicy } = props;
      this.setState(
        {
          ParentIndex,
          leavetypeid: props.leavetypeid,
          isgiftallowed: InitLeavesPolicy.policy[ParentIndex].isgiftallowed,
          isgiftapproval: InitLeavesPolicy.policy[ParentIndex].isgiftapproval,
        },
        () => {
          let giftactiontypeid = {};
          const filterObj = this.state.giftActionType.find(
            (x) =>
              x.displayvalue
              == InitLeavesPolicy.policy[ParentIndex].giftactiontypeid,
          );
          if (filterObj) {
            giftactiontypeid = filterObj;
            this.setState({
              giftactiontypeid,
              giftperc: InitLeavesPolicy.policy[ParentIndex].giftperc,
              noofgift: InitLeavesPolicy.policy[ParentIndex].noofgift,
            });
          }
        },
      );
    } else {
      this.setState({ ...ParentState });
    }
  }

  handleChange(name, ...arg) {
    switch (name) {
      case "isgiftallowed": {
        this.setState(
          {
            [name]: arg[0],
            isgiftapproval: false,
            giftperc: 0,
            noofgift: 0,
            giftactiontypeid: {
              displayname: "Fixed number",
              displayvalue: 2,
            },
          },
          () => this.UpdateReducer(),
        );
        break;
      }
      case "isgiftapproval":
        this.setState({ [name]: arg[0] }, () => this.UpdateReducer());
        break;
      case "giftactiontypeid": {
        const NewState = {
          giftperc: 0,
          noofgift: 0,
        };
        this.setState({ [name]: arg[0], ...NewState }, () => {
          this.UpdateReducer();
        });
        break;
      }
      default:
        break;
    }
  }

  CommonNumberChange(name, max, event) {
    const numbers = /^[0-9]+$/;
    if (event.target.value.match(numbers)) {
      let value;
      if (
        Number(event.target.value) > Number(max)
        || Number.isNaN(event.target.value)
      ) {
        value = this.state[name];
      } else value = Number(event.target.value);
      this.setState({ [name]: value }, () => this.UpdateReducer());
    }
  }

  UpdateReducer = () => {
    const { ParentIndex } = this.state;
    const { InitLeavesPolicy } = this.props;
    if (!InitLeavesPolicy.policy[ParentIndex]) {
      const plan = LeavePlan.find(
        (x) => x.leavetypeid == this.state.leavetypeid,
      );
      InitLeavesPolicy.policy[ParentIndex] = plan.Reducer;
    }
    const giftactiontypeid = this.state.giftactiontypeid
      ? this.state.giftactiontypeid.displayvalue
      : null;
    InitLeavesPolicy.policy[ParentIndex] = {
      ...InitLeavesPolicy.policy[ParentIndex],
      isgiftallowed: this.state.isgiftallowed,
      isgiftapproval: this.state.isgiftapproval,
      giftactiontypeid,
      giftperc: giftactiontypeid != 1 ? this.state.giftperc : null,
      noofgift: giftactiontypeid != 1 ? this.state.noofgift : null,
    };
    this.props.CommonReducerAction(
      ReducersTypes.LEAVESPOLICY,
      InitLeavesPolicy,
    );
  };

  render() {
    const language = this.props.Language.giftaleave;
    return (
      <IntlProvider locale="en" messages={language}>
        <div>
          <p className="form-main-header margin-top-30">
            <FormattedMessage id="LbGiftALeave" defaultMessage="Gift A Leave" />
          </p>
          <div className="inner-wrapper opaque">
            <div className="">
              <p className="depedent-select-list-head">
                <FormattedMessage
                  id="LbGiftLeavebalance"
                  defaultMessage="How about allowing employees to “Gift” their leave balance to colleagues?"
                />
              </p>
              <div
                className="depedent-select-list"
                onClick={() => this.handleChange("isgiftallowed", true)}
                aria-expanded={this.state.isgiftallowed == true}
              >
                <span>
                  {" "}
                  <FormattedMessage id="LbYes" defaultMessage="Yes" />{" "}
                </span>{" "}
                {this.state.isgiftallowed == true ? (
                  <span className="floatright">
                    {" "}
                    <img src={CheckImg} height="20" />{" "}
                  </span>
                ) : (
                  <span className="not-selected " />
                )}
              </div>
              <div className="et-level2">
                <Collapse
                  in={this.state.isgiftallowed}
                  timeout="auto"
                  unmountOnExit
                  className="padding30 overflow-initial"
                >
                  <p className="depedent-select-list-head">
                    <FormattedMessage
                      id="__LbAllowUpto"
                      defaultMessage="Allow employees to gift upto"
                    />
                  </p>
                  {/*
                  "send default 2"
                  <span className="width200p">
                    <Select
                      className="form-control width58"
                      autofocus
                      placeholder="Select Type"
                      options={this.state.giftActionType}
                      getOptionLabel={option => option.displayname}
                      getOptionValue={option => option.displayvalue}
                      onChange={this.handleChange.bind(this, "giftactiontypeid")}
                      value={this.state.giftactiontypeid}
                    />
                  </span> */}
                  <InputValues
                    min="1"
                    max="300"
                    field={
                      this.state.giftactiontypeid.displayvalue == 2
                        ? "noofgift"
                        : "giftperc"
                    }
                    onChange={this.CommonNumberChange.bind(
                      this,
                      this.state.giftactiontypeid.displayvalue == 2
                        ? "noofgift"
                        : "giftperc",
                      300,
                    )}
                    value={
                      this.state.giftactiontypeid.displayvalue == 2
                        ? this.state.noofgift
                        : this.state.giftperc
                    }
                    defaultvalue={
                      this.state.giftactiontypeid.displayvalue == 2
                        ? this.state.noofgift
                        : this.state.giftperc
                    }
                    // disabled={this.state.giftactiontypeid.displayvalue == 1}
                  />
                  <span> leaves in a year </span>
                  {/* <span className='number-wrapper'>
                                        <input
                                            className="seatlimit"
                                            type="number"
                                            min="1"
                                            max="300"
                                            onChange={this.handleChange.bind(this, this.state.giftactiontypeid.displayvalue == 2 ? "noofgift" : "giftperc")}
                                            value={this.state.giftactiontypeid.displayvalue == 2 ? this.state.noofgift : this.state.giftperc}
                                            disabled={this.state.giftactiontypeid.displayvalue == 1}
                                        />
                                    </span> */}
                  <p className="depedent-select-list-head margin-top-20">
                    <FormattedMessage
                      id="LbSpecialApproval"
                      defaultMessage="Special approval required?"
                    />
                  </p>
                  <div
                    className="depedent-select-list"
                    onClick={() => this.handleChange("isgiftapproval", true)}
                    aria-expanded={this.state.isgiftapproval == true}
                  >
                    <span>
                      {" "}
                      <FormattedMessage id="LbYes" defaultMessage="Yes" />{" "}
                    </span>
                    {this.state.isgiftapproval == true ? (
                      <span className="floatright">
                        {" "}
                        <img src={CheckImg} height="20" />{" "}
                      </span>
                    ) : (
                      <span className="not-selected " />
                    )}
                  </div>
                  <div
                    className="depedent-select-list"
                    onClick={() => this.handleChange("isgiftapproval", false)}
                    aria-expanded={this.state.isgiftapproval == false}
                  >
                    <span>
                      {" "}
                      <FormattedMessage id="LbNo" defaultMessage="No" />{" "}
                    </span>
                    {this.state.isgiftapproval == false ? (
                      <span className="floatright">
                        {" "}
                        <img src={CheckImg} height="20" />{" "}
                      </span>
                    ) : (
                      <span className="not-selected" />
                    )}
                  </div>
                </Collapse>
              </div>
              <div
                className="depedent-select-list"
                onClick={() => this.handleChange("isgiftallowed", false)}
                aria-expanded={this.state.isgiftallowed == false}
              >
                <span>
                  <FormattedMessage id="LbNo" defaultMessage="No" />
                </span>
                {this.state.isgiftallowed == false ? (
                  <span className="floatright">
                    <img src={CheckImg} height="20" />
                  </span>
                ) : (
                  <span className="not-selected" />
                )}
              </div>
            </div>
          </div>
        </div>
      </IntlProvider>
    );
  }
}
GiftALeave.propTypes = {
  classes: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  InitLeavesPolicy: state.InitLeavesPolicy,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      CommonReducerAction: (type, data) => CommonReducerAction(type, data),
      setHelperText: (data) => setHelperText(data),
    },
    dispatch,
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(GiftALeave)));
